import { useCallback, useMemo } from 'react';

function useDeviceTimeSeriesMarker({
  enabledMarker,
  displayMarker,
  onMarkerHover,
  onMarkerDragEnd,
  onMarkerPlaceEnd,
  onMarkerPlaceCancel
}) {
  const handleDragStart = useCallback((marker, event) => {
    disableZoomPlugin(event.chart);

    return isUserMarker(marker);
  }, []);
  const handleDragEnd = useCallback(
    (marker, event) => {
      enableZoomPlugin(event.chart);

      if (onMarkerDragEnd) {
        onMarkerDragEnd(marker, event);
      }
    },
    [onMarkerDragEnd]
  );
  const handleDragCancel = useCallback((_, event) => {
    enableZoomPlugin(event.chart);
  }, []);
  const handlePlaceStart = useCallback((_, event) => {
    disableZoomPlugin(event.chart);
  }, []);
  const handlePlaceEnd = useCallback(
    (marker, event) => {
      enableZoomPlugin(event.chart);

      if (onMarkerPlaceEnd) {
        onMarkerPlaceEnd(marker, event);
      }
    },
    [onMarkerPlaceEnd]
  );
  const handlePlaceCancel = useCallback(
    (marker, event) => {
      enableZoomPlugin(event.chart);

      if (onMarkerPlaceCancel) {
        onMarkerPlaceCancel(marker, event);
      }
    },
    [onMarkerPlaceCancel]
  );

  return useMemo(
    () => ({
      enabled: enabledMarker,
      onHover: onMarkerHover,
      onDragStart: handleDragStart,
      onDragEnd: handleDragEnd,
      onDragCancel: handleDragCancel,
      onPlaceStart: handlePlaceStart,
      onPlaceEnd: handlePlaceEnd,
      onPlaceCancel: handlePlaceCancel,
      marker: {
        display: displayMarker,
        label: isUserMarker,
        borderColor: 'rgba(0, 80, 130, 1)',
        backgroundColor: 'rgba(6, 116, 159, 0.18)'
      }
    }),
    [
      enabledMarker,
      displayMarker,
      onMarkerHover,
      handleDragStart,
      handleDragEnd,
      handleDragCancel,
      handlePlaceStart,
      handlePlaceEnd,
      handlePlaceCancel
    ]
  );
}

function enableZoomPlugin(chart) {
  if (chart.options.plugins.zoom?.zoom?.drag) {
    chart.options.plugins.zoom.zoom.drag.enabled = true;
  }
}

function disableZoomPlugin(chart) {
  if (chart.options.plugins.zoom?.zoom?.drag) {
    chart.options.plugins.zoom.zoom.drag.enabled = false;
  }
}

function isUserMarker(marker) {
  return !marker.id.startsWith('reboot');
}

export { useDeviceTimeSeriesMarker };
